/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './summaryStyle';

import utils from '../../../utils';
//import { Fragment } from 'react';

export function CartSummary({ cart, currency, showShipping }) {
  const formatMoney = utils.money.formatMoney;
  let totalAmount = "AU " + formatMoney(cart.totalAmount, 2);
  if(currency === 'NZD' && cart.totalAmountNz){
    totalAmount = "NZD " + formatMoney(cart.totalAmountNz, 2);
  }

  // shipping fee on the delivery step (AUD delivery only) - same amount Stripe charges
  const shippingFee = (showShipping && currency !== 'NZD' && cart.shippingFeeAu !== null && cart.shippingFeeAu !== undefined) ? cart.shippingFeeAu : null;
  if (shippingFee !== null) {
    return <div css={style.summary}>
      <div css={style.line}><span>Items</span><span>AU {formatMoney(cart.totalAmount, 2)}</span></div>
      <div css={style.line}><span>Shipping</span><span>AU {formatMoney(shippingFee, 2)}</span></div>
      <div css={style.totalHdr}> Total Amount </div>
      <div css={style.totalAmount}> AU {formatMoney(cart.totalAmount + shippingFee, 2)} </div>
    </div>
  }

  return <div css={style.summary}>
    <div css={style.totalHdr}> Total Amount </div>
    <div css={style.totalAmount}> {totalAmount} </div>
  </div>
}